export default __webpack_public_path__ + "static/media/new-device-initial-setup.72ca98b4.png";